import React from 'react';
import { useSelector } from 'react-redux';
import { FooterStyles } from './footerStyles';
import { formatDayLabel } from '../../utils/functions';

export default function Footer() {
  const timeRange = useSelector((state) => state.data?.timeRange) || [0, 0];
  const endDay = timeRange[1];
  const endDate = Number.isFinite(endDay) ? formatDayLabel(endDay) : '';
  return (
    <FooterStyles>
      <div className="source">
        Events shown on this map are based on ACLED data covering 28 Feb 2026
        through to 8pm AEDT on {endDate} (10:00 CET).
        <br />
        Source:{' '}
        <a
          href="https://acleddata.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          ACLED
        </a>
        <div style={{ width: '100%', height: '30px' }} />
      </div>
    </FooterStyles>
  );
}
